import React from 'react';

// Types
import { GoalItem } from 'Shared/constants/types';

// Components
import GoalName from '../GoalName/GoalName';
import GoalOwner from '../GoalOwner/GoalOwner';
import GoalStatus from '../GoalStatus/GoalStatus';

// Styles
import './GoalCustomTableRow.scss';

type Props = {
  goal: GoalItem;
};

const GoalCustomTableRow = ({ goal }: Props) => {
  const baseClassName = 'GoalCustomTableRow';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__name`}>
        <GoalName goal={goal} showIcon={true} showStatusIndicator={false} />
      </div>
      <div className={`${baseClassName}__owner`}>
        <GoalOwner goal={goal} allowLinkToProfile={false} showName={false} />
      </div>
      <GoalStatus goal={goal} showCompleteIndicator={false} />
    </div>
  );
};

export default GoalCustomTableRow;
